import React from "react";

function ZoomTool(props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21.5V15.5H5V18.1L8.1 15L9.5 16.4L6.4 19.5H9V21.5H3ZM15.9 10L14.5 8.6L17.6 5.5H15V3.5H21V9.5H19V6.9L15.9 10Z"
        fill="#E8EAED"
      />
    </svg>
  );
}

export default ZoomTool;
